import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DashboardLayout, {DashboardPage} from '../layout'
import { useData } from '../../../data'
import { useRouter } from '../../../routes'
import { UploadOutlined, LeftOutlined } from '@ant-design/icons'
import { CTAButton } from '../components'
import  ToolForm  from './toolform'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import {Card, Input, Form, Select, Upload, Checkbox, Button, notification} from 'antd'

const { Option } = Select;

/**
 * Tools Create page
 */

const EditToolPage = (props) => {
    const router = useRouter()
    const [form] = Form.useForm();
    const [cookieKeys, setNewCookieKeys] = useState([])
    const [error, setError] = useState(null)

    const data = useData()
    const tools = data.tools()

    const useStyles = makeStyles(theme => ({
        error: {
            fontSize: 18,
            color: 'red'
        }
    }))

    const classes = useStyles()

    const getcookieKeys = async () => {
        try {
            const allcookieKeys = await tools.getcookiekeys()
            setNewCookieKeys(allcookieKeys)
        } catch (error) {
            console.log(error.message)
        }

    }
     /**
     * Get data required 
     */
      useEffect(() => {
        getcookieKeys()
        // eslint-disable-next-line
    }, [])

    const { promiseInProgress } = usePromiseTracker()
    
    const {query, state} = router 
    const toolId = query && query.id

    /**
     * Redirect back if there is no tool id in query params
     */
    if(!toolId){
        router.back()
    }

    const updateTool = details => {
        setError(null)
        const tools = data.tools()
        if (!promiseInProgress) {
            trackPromise(
                tools.updateTool(details, toolId)
                .then(data => {
                    notification.success({
                        message: "Tool updated successfully."
                    })
                    router.push(`/dashboard`)
                })
                .catch(err => {
                    console.log(err.message)
                    setError("An error occured")
                    notification.error({
                        message: "Error while updating tool",
                        description: "An error occured while updating tools. Check console for logs"
                    })
                })
            )
        }
    }

    const goBack = () => {
        router.push(`/dashboard`)
    }

    return (
        <DashboardLayout selected="edit_tool" >
            <DashboardPage title="Edit a new Tool" 
                ctaIcon={<LeftOutlined />}
                buttonText="Back"
                onCtaClick={() => goBack()}
            >

                <Card title="Tool information">

                    {/* Tool form */}
                    <ToolForm form={form} tool={state} isEdit={true} onFinish={updateTool}/>

                </Card>
    
            </DashboardPage>
        </DashboardLayout>
    )
}

export default EditToolPage